"use strict";
exports.__esModule = true;
exports.checkCommandGroupByPlusColorBy = exports.nodeDetailsNotNeeded = void 0;
var VALID_COMMANDS = [
    'PORTFOLIO_UNCERTAINTY'
];
exports.nodeDetailsNotNeeded = [
    'INPUT_SCREEN',
    'IMAGE',
    'TORNADODIST',
    'METALOG_DISPLAY',
];
function checkCommandGroupByPlusColorBy(command, reportOptionStr) {
    // if (VALID_COMMANDS.some(c => c === command)) {
    //     return true;
    // } else {
    //     const reportOptionsObj = JSON.parse(atob(reportOptionStr));
    //     if (reportOptionsObj.groupKey == reportOptionsObj.colorKey) {
    //         return true
    //     } else {
    //         return !(reportOptionsObj.groupKey && reportOptionsObj.colorKey);
    //     }
    // }
    return true;
}
exports.checkCommandGroupByPlusColorBy = checkCommandGroupByPlusColorBy;
//# sourceMappingURL=some-logic.js.map


// WEBPACK FOOTER //
// ./app/views/workbench/app/js/logic/some-logic.js